
















































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { RateSourceModule } from '@/store/Products/RateSourceModule';
import CreateRateRequest from '@/models/Products/Rates/CreateRateRequest';

@Component({ name: 'RateCreate' })
export default class extends SaascadaVueDialog {

    dateAsString: string = '';
    rateAsString: string = '';

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.dateAsString = '';
            this.rateAsString = '';
        }
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;
            const request = new CreateRateRequest();
            request.fromDate = new Date(this.dateAsString + "T00:00:00Z")
            request.rate = parseFloat(this.rateAsString);
            await RateSourceModule.createRate(request);
        }
    }

}
